// Dữ liệu mẫu board Mint-Import (hàng nhập) và Mint-HS (tư vấn HS), bản v486, "hôm nay" = 22/Oct/2026.
// Tiền (phí dự kiến, cược, claim) nằm trong `money`, chỉ màn có quyền `money` được đọc.
import type {
  Claim, ClaimParty, ClaimState, ContainerFree, CustomsDecl, Deposit, DepositState, DoState, FreeKind, HsCandidate, HsFta, HsLookup, ImportShipment, Lane,
  OffTariff, PreAlert, ReeferCont, ReeferStatus,
} from './types';

export const TODAY = 22;

const s = (id: string, cus: string, cargo: string, vessel: string, lane: string, eta: string, preAlert: PreAlert, doState: DoState, refs: string): ImportShipment => ({ id, cus, cargo, vessel, lane, eta, preAlert, doState, refs });

export const SHIPMENTS: readonly ImportShipment[] = [
  s('RI260650400', 'NPFruit', 'Trái cây đông lạnh · 1×40RH', 'SAWASDEE VEGA 2606S', 'INC → SGN', '23/Oct/2026', 'Đủ', 'unpaid', 'MBL MRLL260207I · HBL MRLL260207I'),
  s('RI260644890', 'THANHHAO', 'Hàng lạnh · 1×20RF', 'KMTC SURABAYA 2601S', 'INC → SGN', '22/Oct/2026', 'Đủ', 'ok', 'MBL HASLK02260101163'),
  s('RI250628690', 'NDP', 'Hàng lạnh · 1×40RH', 'CSCL INDIAN OCEAN 073E', 'DMM → SGN', '21/Oct/2026', 'Đủ', 'overdue', 'MBL OOLU4054888210'),
  s('RI250620910', 'NEWWIND', 'Hàng lạnh · 1×40RH', 'KOTA NEBULA 0166N', 'CCU → SGN', '25/Oct/2026', 'Thiếu PL', 'ok', 'MBL CCU500308900'),
  s('RI250590940', 'YuMi', 'Hàng lạnh · 1×20RF', 'CNC SATURN 3CGI1S1NC', 'UKB → SGN', '22/Oct/2026', 'Đủ', 'issued', 'MBL AMP0508865'),
  s('RI250587880', 'RuiTong-SC', 'Hàng khô · 3×20DC', 'GSL AFRICA 971S', 'NGB → SGN', '20/Oct/2026', 'Đủ', 'issued', 'MBL YMJAI232305195'),
  s('RI250578840', 'HUONGDUA', 'Hàng khô · 1×20DC', 'EVER OMNI 041B', 'TXG → SGN', '24/Oct/2026', 'Chờ', 'over', 'MBL OOLU2762115310'),
  s('RI250518930', 'VJTrading', 'Hàng lạnh · 1×20RF', 'CNC JUPITER 3CGG3S1NC', 'YOK → SGN', '19/Oct/2026', 'Đủ', 'issued', 'MBL AMP0484344'),
];

/** Lý do khoá / mở DO theo trạng thái (board `DOK`). */
export const DO_WHY: Record<DoState, string> = {
  ok: 'Đã thanh toán lô',
  issued: 'Phát 20/Oct 15:12',
  unpaid: 'Chưa thanh toán lô',
  overdue: 'Quá hạn công nợ 38 ngày',
  over: 'Vượt hạn mức',
};

const c = (cont: string, job: string, cus: string, carrier: string, kind: FreeKind, freeCarrier: number, freeCustomer: number, used: number, start: string, phase: 'RF' | 'DC', buy: number, sell: number): ContainerFree => ({
  cont, job, cus, carrier, kind, freeCarrier, freeCustomer, used, start, phase, money: { buy, sell },
});

export const CONTAINERS: readonly ContainerFree[] = [
  c('FBIU5484924', 'RI250628690', 'NDP', 'OOCL', 'DEM + điện', 5, 7, 9, 'Dỡ 17/Oct', 'RF', 9.6, 12.8),
  c('FSCU5889728', 'RI260650400', 'NPFruit', 'Heung-A', 'DEM', 5, 7, 6, 'Dỡ 16/Oct', 'DC', 0, 0),
  c('ONEU9084924', 'RI250592490', 'NDP', 'ONE', 'DEM', 5, 7, 6, 'Dỡ 16/Oct', 'DC', 0, 0),
  c('TRIU6670229', 'RI260644890', 'THANHHAO', 'Heung-A', 'DET', 7, 10, 4, 'Lấy 18/Oct', 'DC', 0, 0),
  c('OOLU0320399', 'RI250578840', 'HUONGDUA', 'OOCL', 'DET', 7, 7, 8, 'Lấy 14/Oct', 'DC', 3.2, 4.6),
  c('CGMU3012754', 'RI250518930', 'VJTrading', 'CNC', 'DET', 7, 7, 8, 'Lấy 14/Oct', 'DC', 3.2, 4.6),
  c('SEGU9594601', 'RI250606400', 'NDP', 'KMTC', 'DEM', 4, 5, 3, 'Dỡ 19/Oct', 'DC', 0, 0),
  c('FBIU5232460', 'RI250620910', 'NEWWIND', 'PIL', 'DET', 10, 12, 11, 'Lấy 11/Oct', 'DC', 1.8, 2.4),
];

const d = (id: string, job: string, cus: string, lane: Lane, schedule: string, tariffFee: number, offTariffNote: string, offTariff: OffTariff, owner: string): CustomsDecl => ({
  id, job, cus, lane, schedule, owner, offTariffNote, offTariff, money: { tariffFee },
});

export const DECLS: readonly CustomsDecl[] = [
  d('105928817420', 'RI260650400', 'NPFruit', 'R', '23/Oct/2026 08:30 · Cát Lái', 2.8, 'Rút ruột 2×40HC · 4,5 tr', 'wait', 'HAI'),
  d('105928811032', 'RI260644890', 'THANHHAO', 'Y', 'Kiểm hồ sơ · không kiểm hàng', 0.6, '—', 'none', 'NGỌC'),
  d('105928806654', 'RI250620910', 'NEWWIND', 'X', '22/Oct/2026 14:00 · soi CMIT', 1.2, '—', 'none', 'HAI'),
  d('105928799018', 'RI250587880', 'RuiTong-SC', 'G', '—', 0, '—', 'none', 'NGỌC'),
  d('105928790771', 'RI250628690', 'NDP', 'R', '21/Oct/2026 · kiểm dịch + kiểm hoá', 3.4, 'Lưu bãi lạnh thêm 2 ngày · 6,8 tr', 'ok', 'HAI'),
  d('105928781205', 'RI250518930', 'VJTrading', 'G', '—', 0, '—', 'none', 'NGỌC'),
];

const r = (cont: string, job: string, cus: string, setTemp: string, vent: string, received: string, dropped: string, pti: ReeferCont['pti'], status: ReeferStatus): ReeferCont => ({ cont, job, cus, setTemp, vent, received, dropped, pti, status });

export const REEFERS: readonly ReeferCont[] = [
  r('FBIU5484924', 'RI250628690', 'NDP', '−18,0 °C', 'Đóng', '−17,6 °C · 21/Oct 07:40', '—', 'Đạt', 'ok'),
  r('SZLU2019991', 'SE260637290', 'MKSF', '−18,0 °C', 'Đóng', '−11,2 °C · 22/Oct 06:15', '—', 'Đạt', 'dev'),
  r('SEGU9974345', 'SE260634450', 'COCOGROUP', '+4,0 °C', '25 CBM/h', '+4,3 °C · 22/Oct 08:02', '—', 'Đạt', 'ok'),
  r('TCLU1911247', 'SE260623250', 'MCSEA', '−20,0 °C', 'Đóng', '−19,8 °C · 19/Oct 22:10', '−19,9 °C · 20/Oct 03:30', 'Đạt', 'ok'),
  r('YMLU5438708', 'SE260609200', 'EMDEES', '+13,0 °C', '15 CBM/h', 'Chưa có ảnh', '—', 'Chờ PTI', 'miss'),
];

const p = (cont: string, carrier: string, cus: string, deposit: number, returned: string, expectedRefund: string, refunded: number, deducted: number, reason: string, evidence: string, st: DepositState): Deposit => ({
  cont, carrier, cus, returned, expectedRefund, reason, evidence, st, money: { deposit, refunded, deducted },
});

export const DEPOSITS: readonly Deposit[] = [
  p('OOLU0320399', 'OOCL', 'RuiTong-SC', 3.0, '20/Oct/2026', '04/Nov/2026', 0, 0, '—', '—', 'wait'),
  p('FBIU5232460', 'PIL', 'VJTrading', 2.0, '13/Oct/2026', '27/Oct/2026', 0, 0.85, 'Vệ sinh cont', 'EIR + 3 ảnh', 'decide'),
  p('MEDU 410028-5', 'MSC', 'HUONGDUA', 2.0, '29/Sep/2026', '13/Oct/2026', 0, 0, '—', '—', 'late'),
  p('ONEU 330981-4', 'ONE', 'NPFruit', 3.0, '25/Sep/2026', '09/Oct/2026', 1.6, 1.4, 'Sửa sàn cont', 'Không có EIR', 'hana'),
  p('WHLU 120344-0', 'Wan Hai', 'THANHHAO', 2.0, '22/Sep/2026', '06/Oct/2026', 2.0, 0, '—', '—', 'done'),
];

const k = (id: string, job: string, cus: string, what: string, amount: number, party: ClaimParty, due: string, st: ClaimState, recovered: number): Claim => ({ id, job, cus, what, party, due, st, money: { amount, recovered } });

export const CLAIMS: readonly Claim[] = [
  k('CLM-2610-07', 'SE260637290', 'MKSF', 'Lệch nhiệt độ −11,2 °C khi nhận cont', 640.0, 'Hãng tàu', '24/Oct/2026', 'open', 0),
  k('CLM-2610-05', 'RI250606400', 'NDP', 'Móp 3 kiện khi rút hàng tại kho', 42.0, 'Nhà xe', '23/Oct/2026', 'chase', 0),
  k('CLM-2610-03', 'SE260622020', 'NEWWIND', 'Vỡ 12 thùng gốm, có biên bản giám định', 118.5, 'Kho', '—', 'closed', 18.5),
  k('CLM-2610-01', 'SE260634750', 'TAMNGOC', 'Chậm giao 3 ngày do HANA nộp SI trễ', 35.0, 'HANA', '—', 'bod', 35.0),
];

// ---- Mint-HS: hàng mẫu "Máy pha cà phê tự động 1.450W" của VINAVARIETY ----
export const HS_CUSTOMER = 'VINAVARIETY';
export const HS_DESC = 'Máy pha cà phê tự động, xay & pha espresso, điện 220V 1.450W, bình 1,8L, vỏ nhựa ABS + thép không gỉ, dùng gia đình. Đóng thùng carton 1 bộ/thùng.';
/** Xuất xứ gợi ý theo chiều (NK = nhập khẩu vào VN, XK = xuất khẩu đi nước nhập). */
export const HS_ORIGINS = {
  NK: ['Trung Quốc', 'Hàn Quốc', 'Nhật Bản', 'Thái Lan', 'Đức (EU)', 'Malaysia'],
  XK: ['Hoa Kỳ', 'Nhật Bản', 'Hàn Quốc', 'Đức (EU)', 'Úc', 'Canada'],
} as const;

export const HS_CANDIDATES: readonly HsCandidate[] = [
  { code: '8516.71.00', name: 'Dụng cụ pha chè hoặc cà phê, dùng điện', conf: 92, ftaIndex: 0, tax: ['37,5%', '25%', '10%', '0%', '0%', '—'], why: 'Máy pha cà phê gia dụng 1.450W, đun nước bằng điện trở → nhóm 85.16 (thiết bị nhiệt điện gia dụng), phân nhóm 8516.71 đích danh “coffee or tea makers”. Quy tắc 1 và 6.' },
  { code: '8516.79.90', name: 'Thiết bị nhiệt điện gia dụng khác', conf: 5, ftaIndex: 1, tax: ['30%', '20%', '10%', '0%', '0%', '—'], why: 'Mã khách gợi ý. Chỉ dùng khi hàng không có chức năng pha (ví dụ chỉ đun nước). Mô tả có “tự động xay & pha” nên loại.' },
  { code: '8419.81.10', name: 'Máy pha cà phê, đun nóng thức ăn — dùng trong thương mại', conf: 3, ftaIndex: 2, tax: ['7,5%', '5%', '10%', '0%', '0%', '—'], why: 'Chỉ khi là máy công nghiệp/quán (không dùng điện gia dụng hoặc công suất lớn). Công suất 1.450W, bán lẻ → không thuộc.' },
];
/** Tên 6 loại thuế theo thứ tự `HsCandidate.tax`. */
export const HS_TAX_LABELS = ['NK thông thường', 'NK ưu đãi (MFN)', 'VAT', 'TTĐB', 'Xuất khẩu', 'BVMT'] as const;

const f = (k: string, form: string, origins: string[], rates: [number, number, number], rule: string): HsFta => ({ k, form, origins, rates, rule });

export const HS_FTAS: readonly HsFta[] = [
  f('ACFTA', 'E', ['Trung Quốc'], [0, 5, 0], 'RVC 40%'),
  f('ATIGA', 'D', ['Thái Lan', 'Malaysia'], [0, 0, 0], 'RVC 40% hoặc CTH'),
  f('AKFTA', 'AK', ['Hàn Quốc'], [0, 5, 0], 'RVC 40% hoặc CTH'),
  f('VKFTA', 'VK', ['Hàn Quốc'], [0, 0, 0], 'RVC 40% hoặc CTH'),
  f('AJCEP', 'AJ', ['Nhật Bản'], [5, 5, 0], 'RVC 40% hoặc CTH'),
  f('VJEPA', 'VJ', ['Nhật Bản'], [0, 3, 0], 'RVC 40% hoặc CTH'),
  f('CPTPP', 'CPTPP / tự chứng nhận', ['Nhật Bản', 'Malaysia', 'Úc', 'Canada'], [3, 3, 0], 'CTSH hoặc RVC 45%'),
  f('EVFTA', 'EUR.1 / REX', ['Đức (EU)'], [4, 4, 0], 'MaxNOM 50% EXW'),
  f('RCEP', 'RCEP', ['Trung Quốc', 'Hàn Quốc', 'Nhật Bản', 'Thái Lan', 'Malaysia', 'Úc'], [8, 10, 0], 'RVC 40% hoặc CTH'),
];

const lk = (code: string, name: string, meta: string, status: string, tone: HsLookup['tone']): HsLookup => ({ code, name, meta, status, tone });

export const HS_RECENT: readonly HsLookup[] = [
  lk('8516.71.00', 'Máy pha cà phê tự động 1.450W', 'VINAVARIETY · đang tra', 'Chờ xác nhận', 'warn'),
  lk('9403.60.90', 'Tủ bếp gỗ cao su lắp ráp', 'VINAVARIETY · 21/Oct/2026', 'Đã xác nhận', 'ok'),
  lk('0901.21.20', 'Cà phê rang xay đóng gói 500g', 'GREENBUD · 20/Oct/2026', 'Đã xác nhận', 'ok'),
  lk('6006.22.00', 'Vải dệt kim sợi bông đã nhuộm', 'COCOGROUP · 19/Oct/2026', 'Đã xác nhận', 'ok'),
  lk('3923.21.99', 'Túi PE in logo', 'SAVITA · 18/Oct/2026', 'Trả lại', 'err'),
  lk('6911.10.00', 'Bộ ấm chén sứ', 'TAMNGOC · 17/Oct/2026', 'Đã xác nhận', 'ok'),
];

export const HS_PENDING: readonly HsLookup[] = [
  lk('8516.71.00', 'Máy pha cà phê tự động 1.450W', 'NHIDTT · hạn 23/Oct/2026 11:00', 'còn 6h', 'warn'),
  lk('8471.30.20', 'Máy tính bảng 10 inch', 'HOATTN · BAOANVISION · hạn 23/Oct/2026 16:00', 'còn 11h', 'pri'),
  lk('0306.17.11', 'Tôm thẻ đông lạnh nguyên con', 'NHIDTT · THANHHAO · hạn 22/Oct/2026 15:00', 'trễ 1h', 'err'),
];
